import { Injectable } from '@angular/core';
import { ToastOptions } from '@models/toast.models';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly defaultToastOptions: ToastOptions = {
    type: 'success',
    title: '',
    actionText: '',
    inline: false,
    duration: 5000,
    position: 'absolute',
    placement: 'top',
    autoHide: true,
    animate: true,
  };

  private readonly toastOptions$$ = new BehaviorSubject<ToastOptions | null>(null);
  private actionEvent$ = new Subject<void>();
  private closeEvent$ = new Subject<void>();

  public showToast(toastOptions: ToastOptions | null): void {
    const options = toastOptions ? { ...this.defaultToastOptions, ...toastOptions } : null;
    this.toastOptions$$.next(options);
  }

  triggerAction(): void {
    this.actionEvent$.next();
  }

  triggerClose(): void {
    this.closeEvent$.next();
  }

  public getToastOptions$(): Observable<ToastOptions | null> {
    return this.toastOptions$$.asObservable();
  }

  get action$(): Observable<void> {
    return this.actionEvent$.asObservable();
  }

  get close$(): Observable<void> {
    return this.closeEvent$.asObservable();
  }
}
